import { type RootState } from '../../../rmsReduxStore/rmsStore'

export default function getAcReferenceDataReducer(state: RootState): AcReferenceDataState {
  return state.acReferenceDataReducer;
}

